import api from '../api';

/**
 * Gets the content of a notification by its ID.
 *
 * @param {string} id - The ID of the notification.
 * @return {Promise<string>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const getNotificationContent = async (id) => {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/notification/content`;
  try {
    const response = await api.get(endpoint, {
      params: { id }
    });

    return response.data;
  } catch (error) {
    console.error('Error getting notification content:', error);
    throw error;
  }
}

export default getNotificationContent;
